module.exports = __webpack_public_path__ + "img/bg1.961a1f75.png";